export default "__VITE_ASSET__DRGyAwZS__"